export enum PageSpeedTab {
  SUMMARY = "SUMMARY",
  PERFORMANCE = "PERFORMANCE",
  STRUCTURE = "STRUCTURE",
  WATERFALL = "WATERFALL",
  HISTORY = "HISTORY",
}
